module.exports = __webpack_public_path__ + "static/img/pggsv.8ea797a7.png";